export const SET_TABLE_PATHS = "SET_TABLE_PATHS";
